import { Box, IconButton, Menu } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import React from "react";
import DashBoardNotifcation from "../DashBoardNotifcation/DashBoardNotifcation";

function Notifcation({ data, userId, totalMessage }) {
  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <IconButton
            className={totalMessage != 0 ? "mover-notifcation" : ""}
            sx={{
              borderRadius: "8px",
              width: "32px",
              mr: "16px",
              height: "32px",
            }}
            {...bindTrigger(popupState)}
          >
            <Box sx={{ position: "relative" }}>
              {totalMessage != 0 && (
                <span
                  className="font-num"
                  style={{
                    position: "absolute",
                    backgroundColor: "#FBE8EE",
                    top: "-10%",
                    zIndex: 10,
                    color: "#D4164F",
                    borderRadius: "50px",
                    width: "18px",
                    height: "18px",
                    right: "70%",
                    fontSize: "14px",
                  }}
                >
                  {totalMessage}
                </span>
              )}
              <i className="icon-Bell"> </i>
            </Box>
          </IconButton>
          <Menu
            {...bindMenu(popupState)}
            sx={{
              "& .MuiMenu-paper": {
                right: "9% !important",
                borderRadius: "8px",
              },
              "& .MuiMenu-list": { paddingTop: "0" },
            }}
          >
            <DashBoardNotifcation data={data} userId={userId} />
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}

export default Notifcation;
